import { Component, Inject, OnInit } from '@angular/core';
import { IEnvironment } from 'libs/core/src/lib/_environment/interface';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/public-api';

@Component({
  selector: 'app-footer',
  template: ''
})
export class FooterComponent implements OnInit {
  env!: IEnvironment;
  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any) {
    this.env = environment;
  }

  ngOnInit() {}
}
